module.exports = __webpack_public_path__ + "img/2.3bbfbd22.png";